module.exports = __webpack_public_path__ + "static/media/tlyfe-black-logo.831cb343.png";